export const awardMoney = (value)=>`$${Math.round(value / 1e6)}M`;
export function awardsModel(series, fy) {
    const usIds = new Set(series.years.flatMap((y)=>y.segments.filter((s)=>s.isUs || s.key === 'us').map((s)=>s.company?.id ?? '')));
    const winners = series.winners.filter((w)=>!usIds.has(w.id)).slice(0, 3);
    const segments = [
        {
            key: 'us',
            label: 'Us',
            tone: 'ours'
        },
        ...winners.map((w, i)=>({
                key: w.id,
                label: w.name,
                tone: [
                    'cat-1',
                    'cat-2',
                    'cat-3'
                ][i]
            })),
        {
            key: 'others',
            label: 'Others',
            tone: 'other'
        }
    ];
    const columns = Array.from({
        length: 8
    }, (_, i)=>{
        const year = fy - 7 + i;
        const data = series.years.find((y)=>y.fiscalYear === year);
        const values = {};
        for (const s of data?.segments ?? []){
            const key = s.isUs || s.key === 'us' ? 'us' : winners.some((w)=>w.id === s.key) ? s.key : 'others';
            values[key] = (values[key] ?? 0) + s.amount;
        }
        const total = Object.values(values).reduce((sum, v)=>sum + Math.max(0, v), 0);
        return {
            id: String(year),
            label: String(year),
            values,
            totalLabel: awardMoney(total)
        };
    });
    const withData = columns.filter((c)=>Object.values(c.values).some((v)=>v > 0));
    const first = withData[0];
    const last = withData.at(-1);
    const share = (c)=>Math.round(100 * (c.values.us ?? 0) / Object.values(c.values).reduce((s, v)=>s + Math.max(0, v), 0));
    const insight = [];
    if (first && last && first !== last && withData.some((c)=>(c.values.us ?? 0) > 0)) insight.push(`Our share went from ${share(first)}% to ${share(last)}% in ${Number(last.id) - Number(first.id)} ${Number(last.id) - Number(first.id) === 1 ? 'year' : 'years'}.`);
    if (withData.length && winners[0]) insight.push(`${winners[0].name} still wins the most here.`);
    if (series.setAside?.enoughData) insight.push(`About ${series.setAside.percentRounded5}% of the office's awards are small-business set-asides.`);
    return {
        segments,
        columns,
        insight: insight.join(' '),
        empty: !withData.length
    };
}
